//src\components\Inventory-Stocks & Orders\Admin\StockOrder\StockOrderSkeleton.tsx
import React from "react";

export const Skeleton: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`}></div>
);

export const OrderItemSkeleton = () => (
  <div className="border rounded-lg p-4 bg-white border-gray-200">
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-3">
        <Skeleton className="w-6 h-6 rounded-full" />
        <div>
          <Skeleton className="h-4 w-32 mb-2" />
          <Skeleton className="h-3 w-24" />
        </div>
      </div>
      <Skeleton className="h-3 w-16" />
    </div>
  </div>
);

export const OrderDetailsSkeleton = () => (
  <div className="bg-white border border-gray-200 p-6 h-[calc(100vh-64px)] overflow-y-auto">
    <div className="mb-4">
      <Skeleton className="h-4 w-24 mb-2" />
      <Skeleton className="h-6 w-48" />
    </div>

    {/* Prescription image skeleton */}
    <div className="mb-6">
      <Skeleton className="h-64 w-full rounded" />
    </div>

    {/* Product items skeleton */}
    <div className="space-y-4 mb-6">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="flex items-center gap-4">
          <Skeleton className="w-12 h-12 rounded" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
            <Skeleton className="h-3 w-2/3" />
          </div>
          <Skeleton className="w-8 h-8 rounded-full" />
        </div>
      ))}
    </div>

    {/* Delivery info skeleton */}
    <div className="space-y-3 mb-6">
      <Skeleton className="h-5 w-32" />
      {[...Array(4)].map((_, i) => (
        <Skeleton key={i} className="h-4 w-full" />
      ))}
    </div>

    {/* Button skeleton */}
    <Skeleton className="h-10 w-32 rounded-md" />
  </div>
);